import type { Component, ShapeDividerStyle } from '@wix/thunderbolt-becky-types'
import { createCssCompNode } from '../cssCompNode'
import type { FeatureRefs } from '../cssFeatures.types'
import { getBackgroundProps } from './utils'
import { isRefArray } from '../../utils/variantsUtils'
import { toBreakpointVariantsMap } from '../../utils/toBreakpointVariantsMap'
import { toCompVariants } from '../../utils/toCompVariants'
import { color } from '@wix/thunderbolt-commons'

const { isHexValue } = color

export const svgBackgroundImage = createCssCompNode('svgBackgroundImage', 'svgBackgroundImage', {
	getDependencies: (component: Component, refs: FeatureRefs<'svgBackgroundImage'>) => {
		return component?.builderType ===
			'wixSystemElements.BackgroundShapeDivider' &&
			component.styleId
			? {
				compStyle: refs.styleId(component.styleId),
				variablesList: refs.variablesQuery('variables-masterPage'),
			}
			: null
	},
	toViewItem: (__, deps) => {
		if (!deps || !deps?.compStyle) {
			return null
		}

		const { compStyle, variablesList } = deps

		const getStyleObj = (style: ShapeDividerStyle) => {
			const { cssCustomProperties, resolvedSvg, id } = style
			const { side, repeats, invert, keepAspectRatio, height, color, svgId } = cssCustomProperties || {}

			const hasNoneOverride = svgId === JSON.stringify('')

			if ((!hasNoneOverride && !resolvedSvg) || !id || !side) {
				return null
			} else if (hasNoneOverride) {
				return {
					'[data-divider-layer]': {
						'background-image': 'none',
					},
				}
			}

			let fill = color || '#000'

			if (!isHexValue(fill) && fill.startsWith('var(--')) {
				const cssVarName = fill.replace('var(--', '').replace(')', '')
				const cssColorVar = variablesList?.variables?.find((entry) => entry?.cssVarName === cssVarName)
				// @ts-ignore
				fill = cssColorVar?.value?.values?.[0]?.value
			}

			const { backgroundImage, backgroundSize } = getBackgroundProps({
				id,
				svg: resolvedSvg,
				side,
				height: height || '150px',
				color: fill,
				invert: invert === 'invert',
				keepAspectRatio: keepAspectRatio !== 'stretch',
				repeats: repeats ? parseInt(repeats, 10) : 1,
			})

			return {
				'[data-divider-layer]': {
					'background-image': backgroundImage ?? '',
					'background-size': backgroundSize ?? '',
					...(side === 'top' ? { top: '0', '--scaleY': '-1' } : { bottom: '0', '--scaleY': '1' }),
				},
			}
		}

		if (isRefArray(compStyle)) {
			// @ts-ignore
			const data = toBreakpointVariantsMap(compStyle.values, getStyleObj)
			return {
				data,
				variants: toCompVariants(compStyle.values),
			}
		} else {
			return {
				data: {
					default: {
						// @ts-ignore
						'': getStyleObj(compStyle),
					},
				},
				variants: null,
			}
		}
	},
})
